// Import Packages
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";

// Import Material UI
import { IconButton } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ExpandLessRounded from '@material-ui/icons/ExpandLessRounded';
import BugReportIcon from '@material-ui/icons/BugReport';
import ErrorSharpIcon from '@material-ui/icons/ErrorSharp';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

// Import Pages
import Info from "../../../../autom/editAction/components/Info";
import { libraryIcons } from '../../../../autom/NewFlowLibraryAssetManager';
import OptionsMenu from '../options/OptionsMenu';
import { alertState, triggerConf, renameTime, openDebugRunning, itemExpand, saveAvailable, changedFields, baseOrigin } from "../../../../../../../recoil-store/recoil-state";
import TriggerItem from '../triggerItem/TriggerItem';
import TriggerReset from '../triggerReset/TriggerReset';
import AddActionModal from '../AddActionModal/AddActionModal';
import ItemLabel from './ItemLabel/ItemLabel';

// Import Services
import AutomService from "../../../../../../../services/AutomService/AutomService";

// Icons
import editDesktopActionIcon from '../../../../../../../assets/icons/actionIcons/desktop-recorder-actions-edit.svg'
import addActionIcon from '../../../../../../../assets/icons/new-add-action-icon.svg';

// Import Helpers
import { fixBaseOrigin, findDifferent, getVariableIcon } from "../../../../../../../helpers/helper";

// Import CSS
import './Item.css';

const areEqual = (prevProps, nextProps) => {
    let isSame = true
    isSame = findDifferent(prevProps.item, nextProps.item, prevProps, nextProps)
    return isSame;
};


const Item = React.memo(({
    item,
    index,
    handleDragStart,
    isConditionChild = false,
    conditionFlow,
    setActiveItem,
    setDetailTabs,
    detailTabs,
    deleteItem,
    isFocused,
    condition,
    groupable,
    hiddenParent,
    setDialog,
    debuggingStart,
    handleErrorOpenClick,
    handleErrorCloseClick,
    setShowTriggerRightArea,
    setOpenTriggerConfigure,
    setTriggerOffSet,
    openResetTriggerConfiguration,
    isEhFlow,
    handleTrigger,
    setReCheck,
    automaticallyVariableCreation,
    setTriggerModal,
    setOpenSchedule,
    updateVariableByItemId,
    isDesktopRecorder,
    desktopActionsEditDialog,
    changeLabelField,
    resetWPSession,
    setActions,
    handleOpenErrorHandlingAutom,
    GotoAction,
    setTriggerType,
    handleOnDrop,
}) => {
    const setAlert = useSetRecoilState(alertState);
    const { t } = useTranslation();
    const [expand, setExpand] = useRecoilState(itemExpand);
    const [actionLabel, setActionLabel] = useState(item?.label);
    const [changeLabel, setChangeLabel] = useState(false);
    const [showAddActionModal, setShowAddActionModal] = useState({ status: false });
    const debugRunning = useRecoilValue(openDebugRunning);
    // const [openSetTriggerType, setOpenSetTriggerType] = useState(false);
    const ref = useRef(null);
    const refDebug = useRef(null);
    const nodeRef = useRef(null);
    const label = 'CONTENT.FLOW.'
    const triggerStaticTriggerLabel = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    // const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);
    const setRenameTime = useSetRecoilState(renameTime);
    const ifAction = useRef()
    const base_origin = useRecoilValue(baseOrigin);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);

    // useEffect(() => {
    //     horizontalLineStyleCalculator();
    // }, [groupable]);
    // setting size of "else" and "else if" actions according to their positioning
    const lineDefinition = item.actionName !== 'ELSEIF' && item.actionName !== 'ELSE' ? "horizontal-condition-row" : `horizontal-condition-row ${conditionFlow === "column" ? "ml-60" : ""}`

    // const horizontalLineStyleCalculator = () => {
    //     debugger;
    //     const iconWidth = 60;
    //     const staticAdditionalWidth = 8;
    //     const staticAdditionalLeft = 5;
    //     const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
    //     Array.prototype.forEach.call(conditionHoverLines, function (el) {
    //         // Do stuff here
    //         const sEl = findAncestor(el, "horizontal-condition-row");
    //         const leftPosition = (sEl.offsetWidth / 2) + (iconWidth / 2) + staticAdditionalLeft;
    //         const actualWidth = (sEl.offsetWidth - leftPosition) + staticAdditionalWidth;
    //         el.style.width = actualWidth + "px";
    //         el.style.left = leftPosition + "px";
    //     });
    // }
    // const dashedLineStyleCalculator = () => {
    //     const element = ifAction.current
    //     const nextElement = element.nextSibling
    //     if (nextElement?.classList.value.includes("groupable-flow-container")) {
    //         const dashedLine = !isDesktopRecorder ? document.querySelector(`.dst_${item.id}`) : document.querySelector(`.dialog-desktop-actions .dst_${item.id}`)
    //         const parentElement = dashedLine.parentElement
    //         const parentElementWidth = parentElement.offsetWidth
    //         const nextElementWidth = nextElement.offsetWidth
    //         dashedLine.classList.remove("d-n")
    //         dashedLine.style.left = parentElementWidth / 2 + "px"
    //         dashedLine.style.width = (parentElementWidth / 2) + 60 + (nextElementWidth - (item.libraryName === "WHATSAPP" ? 0 : 60)) / 2 + "px"
    //         if (item.actionName === "ELSEIF") {
    //             dashedLine.style.borderLeft = 0
    //         }
    //     }
    // }

    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }


    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e?.target) {
            if (e?.target?.className.trim().includes('new-flow-drag-hover')) {
                e.target.style.border = '1px dashed #46474E';
                if (e.target.previousSibling?.firstChild) {
                    // This is done so that the + icon does not interfere with the drag and drop operation.
                    e.target.previousSibling.firstChild.firstChild.style.zIndex = "999";
                }

            }
        }
    };

    const handleDragLeave = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (e?.target) {
            e.target.style.borderColor = 'transparent';
            if (e.target.previousSibling?.firstChild) {
                // After the drop process is finished, the + icon is made to be clickable again.
                e.target.previousSibling.firstChild.firstChild.style.zIndex = "";
            }
        }
    };

    const doNothing = (e) => {
        e.stopPropagation();
    }

    const openTriggerSelectionArea = () => {

    }

    const setTriggerArea = (e) => {
        e.stopPropagation();
        //setShowTriggerRightArea(true);
        let parent = ref.current.offsetParent;
        let left = ref.current.offsetLeft;
        let top = ref.current.offsetTop;
        while (parent.offsetParent) {
            left += parent.offsetLeft;
            top += parent.offsetTop;
            parent = parent.offsetParent;
        }

        setTriggerOffSet({
            left,
            top
        });

        setOpenTriggerConfigure(true);
        //setActiveItem(e, item);
    }
    // trigger type fill and automDetail is set
    // const setTriggerSelection = (e) => {
    //     e.stopPropagation();
    //     setOpenSetTriggerType(true);
    // }

    const handleSetActive = (e) => {
        e.stopPropagation();
        setShowTriggerRightArea(false);
        setActiveItem(e, item);

    };

    const handleDelete = (cut, isif) => {
        deleteItem(isif ? isif : item, cut);
    };

    const handleExpand = (e) => {
        e.stopPropagation();
        let copyExpand = { ...expand }
        copyExpand[item.id] = !copyExpand[item.id]
        setExpand(copyExpand);
    };

    const handleResetTrigger = async (e) => {
        openResetTriggerConfiguration();
    }

    function handleDebugging(e, action) {
        e.stopPropagation();
        setActiveItem(e, action, "", 'debug');
    }

    const handleDragEnd = () => {
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });

        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            el.classList.remove('active');
        });
    }

    const getExpandStyle = () => {
        if (expand[item.id]) {
            return { minHeight: 0, paddingBottom: 0, background: 'transparent', boxShadow: 'none' };
        }
        if (item.hiddenParent) {
            return { padding: 0, background: 'transparent', boxShadow: 'none', minHeight: 0 };
        }
    };

    const getConditionStyle = () => {
        if (item.hiddenParent) {
            return { boxShadow: 'none', padding: 0, minHeight: 0, height: 0 };
        }
    };

    const handleErrorOpen = () => {
        handleErrorOpenClick(item?.debugErrorMessage);
    }

    const ConditionPicker2 = ({ condition, name, onClick }) => {
        const { t } = useTranslation();
        const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';
        return (
            <div className="condition-picker">
                <fieldset>
                    <legend>&nbsp;<span>{name}</span>&nbsp;</legend>
                    {/* <legend>&nbsp;<span>{condition.condition}</span>&nbsp;</legend> */}
                    <div>
                        <div>
                            <span className="condition-value">{condition.fields.firstValue.value}</span>
                            &nbsp;<span>{t(label + condition.operator.toUpperCase())}</span>&nbsp;
                            <span className="condition-value">{condition.fields.secondValue.value}</span>
                        </div>
                        {/* <div>
                            <button onClick={onClick}><MoreVertIcon /></button>
                        </div> */}
                    </div>
                </fieldset>
            </div>
        );
    }


    const ConditionPicker = ({ conditions, name }) => {
        const { t } = useTranslation();
        const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';
        return (

            <div className="condition-area">
                <div className="form-element wc">
                    <div className="condition-picker oe">
                        <fieldset>
                            <legend>&nbsp;<span>{name}</span>&nbsp;</legend>
                            {/* <legend>&nbsp;<span>{condition.condition}</span>&nbsp;</legend> */}
                            <div>
                                {
                                    conditions.map((condition, conditionI) => (
                                        <div key={conditionI}>
                                            <span className="condition-value">{condition.fields.firstValue.value}</span>
                                            &nbsp;<span>{t(label + condition.operator.toUpperCase())}</span>&nbsp;
                                            <span
                                                className="condition-value">{condition.fields.secondValue.value}</span>
                                            {
                                                condition.logic !== 'last' &&
                                                <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                    <div className="condition-tabs oe">
                                                        <button
                                                            className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            value="and">
                                                            And
                                                        </button>
                                                        <button
                                                            className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            value="or">
                                                            Or
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        )
    }

    const handleWPSession = async () => {
        resetWPSession(item)
    }

    const disableAction = async () => {

    }

    const doubleClick = (actionName) => {
        if (!changeLabel) {
            if (!actionLabel) {
                setActionLabel(actionName);
            }

            setChangeLabel(true);
        }
    }

    // const onChangeLabel = (e) => {
    //     setActionLabel(e.target.value);
    // }

    // const saveLabel = (isCustomAction) => {
    //     setChangeLabel(false);
    //     let copyItems = JSON.parse(JSON.stringify(automDetail.items));
    //     let data = { found: false };
    //     findAndSetLabel(copyItems, data)
    //     // Checking if actions field is not changing
    //     if (data.found) {
    //         //if (isCustomAction) {
    //         updateVariableByItemId(item.item_id, actionLabel);
    //         // }
    //         setAutomDetail({
    //             ...automDetail,
    //             items: copyItems
    //         });
    //         setRenameTime(new Date());
    //     }

    //     const labelChangeManagement = () => {
    //         let oldValue = initialActionsData[item.id]?.label;
    //         if (!oldValue) {
    //             if (item?.library_label?.includes('CUSTOM')) {
    //                 oldValue = item?.action_name
    //             } else {
    //                 oldValue = t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)
    //             }
    //         }

    //         let input_name = 'xAction_label';

    //         // The operations here were performed without any performance problems. There is a performance issue when using the ChangeFields value.
    //         if (oldValue !== actionLabel) {
    //             setChangeFields((prev) => {
    //                 let cfTemp = JSON.parse(JSON.stringify(prev));
    //                 if (!cfTemp[item.item_id]) {
    //                     cfTemp[item.item_id] = [];
    //                 }

    //                 if (!cfTemp[item.item_id].includes(input_name)) {
    //                     cfTemp[item.item_id].push(input_name);
    //                 }
    //                 return cfTemp;
    //             });
    //             setSaveAvailable(true);
    //         } else {
    //             let saveAvailable;
    //             setChangeFields((prev) => {
    //                 let cfTemp = JSON.parse(JSON.stringify(prev));
    //                 if (cfTemp[item.item_id]) {
    //                     let indexToDelete = cfTemp[item.item_id].indexOf(input_name)

    //                     // if the value is found in the array, remove it
    //                     if (indexToDelete > -1) {
    //                         cfTemp[item.item_id].splice(indexToDelete, 1);
    //                     }

    //                     if (cfTemp[item.item_id].length < 1) {
    //                         delete cfTemp[item.item_id];
    //                     }
    //                 }
    //                 if (Object.keys(cfTemp).length < 1) {
    //                     saveAvailable = false;
    //                 } else {
    //                     saveAvailable = true;
    //                 }
    //                 return cfTemp;
    //             });
    //             setTimeout(() => {
    //                 // Written to be safe due to asynchronous operation
    //                 setSaveAvailable(saveAvailable);
    //             }, 300)
    //         }
    //     };

    //     labelChangeManagement();
    // }

    // const findAndSetLabel = (items, data) => {
    //     for (const i in items) {
    //         if (items[i].item_id === item.item_id) {
    //             if (items[i].label !== actionLabel) {
    //                 items[i].label = actionLabel
    //                 data.found = true;
    //             }
    //             break;
    //         } else if (items[i].hasOwnProperty('children')) {
    //             items[i].children = findAndSetLabel(items[i].children, data);
    //             if (data.found) {
    //                 break;
    //             }
    //         }
    //     }
    //     return items;
    // }

    const standard = () => {
        return (
            <div className="new-flow-item-line"
                ref={ref}
                onDragOver={(e) => e.preventDefault()}
                onDragStart={(e) => handleDragStart(e, item, true)}
            >
                <div className={`option-container ${item?.item_id !== undefined ? item?.debugStatus : ""}`}
                    id={`act_${item?.item_id !== undefined ? item?.item_id : item?.id}`}
                    style={{ paddingLeft: 20, paddingRight: 20 }}>
                    {/* <WarningRoundedIcon className="new-flow-warning-icon" id={'flow-warning' + item.id} /> */}
                    {item.actionName !== 'START' && (
                        <Info value={t("CONTENT.FLOW.SHOW-ERROR")} placement="left">
                            <ErrorSharpIcon
                                onClick={handleErrorOpen}
                                className={`debug-error-icon ${item?.debugStatus === 'error' ? 'show' : ''}`}
                                id={'debug-error' + item.item_id} />
                        </Info>
                    )}
                    {item.actionName !== 'START' && (
                        <Info value={t("CONTENT.FLOW.FIELD-ERROR")} placement="left">
                            <ErrorSharpIcon
                                className={`debug-error-icon error`}
                                id={'flow-warning' + item.id} />
                        </Info>
                    )}
                    {/* {item?.actionName === 'TRIGGER' && < TriggerReset handleResetTrigger={handleResetTrigger} />} */}


                    {item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                        <IconButton disabled={debugRunning} size='small' style={{ left: 0, top: 0, position: 'absolute' }}
                            onClick={(e) => handleDebugging(e, item)}>
                            {debuggingStart && item?.actionName !== 'START' && item?.actionName !== 'STOP' &&
                                <BugReportIcon
                                    fontSize='small'
                                    style={{
                                        fontSize: 17,
                                        color: item.isDebugging ? '#D75E5E' : 'black',
                                        display: debuggingStart ? 'inline-block !important' : 'none !important'
                                    }}
                                />
                            }
                        </IconButton>
                    )}
                    {isDesktopRecorder && item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                        <IconButton size='small' style={{ right: -8, top: 24, position: 'absolute' }}
                            onClick={() => desktopActionsEditDialog(item)}>
                            <img src={editDesktopActionIcon} alt="" />
                        </IconButton>
                    )}
                    {/* border-${item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} */}
                    <div
                        onClick={(e) => {
                            if (e.detail === 1) {
                                item.name !== 'TRIGGER' ? handleSetActive(e) : (triggerConfig && Object.keys(triggerConfig.app).length > 0 ? setTriggerArea(e) : doNothing(e))
                            }
                        }}
                        className={`action-container-border action-icon-border ${item.name === 'TRIGGER' ? (Object.keys(triggerConfig.app).length > 0 ? '' : 'trigger-static-container') : ""} 
                        version-active-${item.libraryName}-${item.version} ${item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' ? "autom-action-count" : ""}`}
                        id={item.name === "START" ? "start-container-border" : ""}>
                        <div
                            id={item.name === 'START' ? 'flow-start' : item.name === 'STOP' ? 'flow-stop' : 'flow-regular'}
                            className={`new-flow-standard-item ${item.name === 'START' || item.name === 'STOP' ? 'start-stop-item' : ''} ${item.name === 'TRIGGER' && triggerConfig && Object.keys(triggerConfig.app).length > 0 ? 'trigger-app-icon' : ''} 
                            ${item.name === 'START' ? 'color-green' : item.name === 'STOP' ? 'color-red' : item.name === 'TRIGGER' ? (Object.keys(triggerConfig.app).length > 0 ? 'color-white' : 'color-blue trigger-static-icon') : 'color-white'}`
                            } draggable>
                            {
                                item.name === 'TRIGGER' && triggerConfig && Object.keys(triggerConfig.app).length > 0 ? (
                                    <img
                                        src={triggerConfig.app?.image_path}
                                        alt={triggerConfig.app?.name}
                                        className="selected-trigger-app" />
                                ) : (
                                    <div
                                        style={item.shade ? { backgroundColor: item.shade } : {}}
                                        className={`${item.shade ? '' : 'color-' + item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} ${item.name === 'START' || item.name === 'STOP' || item.name === 'TRIGGER' ? '' : item.action_label?.includes('CUSTOM') ? 'item-icon color-white' : 'item-icon color-yellow'}`}>
                                        {/* {libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] ? libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] : */}
                                        {
                                            ['START', 'STOP', 'TRIGGER-STATIC'].find(x => x === item.libraryName) ? libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] :
                                                <img style={{ width: 30 }} alt={item.libraryName}
                                                    src={`${item.image_path ? `${base_origin}${item.image_path}` : fixBaseOrigin(base_origin, item.image)}`} />
                                        }
                                    </div>
                                )
                            }
                            {
                                item?.library_label?.includes('CUSTOM') ?
                                    (
                                        <div
                                            onClick={(e) => e.detail === 2 ? doubleClick(item?.action_name) : undefined}
                                            className={`${item.conditions && item.conditions.length && "wc"}  action-item`}
                                            style={{ textAlign: "center", position: "relative" }}>
                                            <span className="action-item-lib">{item?.library_name}</span>
                                            {/* <span style={{ marginLeft: "10px", fontSize: "0.8rem" }}> . v.1.1.0</span> */}
                                            {!changeLabel ?
                                                <div className='action-label-container'>
                                                    <span
                                                        className="action-item-action">{item.label ? item.label : item?.action_name}</span>
                                                    <span className='action-version-label'>v{item.version}</span>
                                                </div> :
                                                // <input style={{ border: '0' }} className="action-item-action"
                                                //     onBlur={() => saveLabel(true)} autoFocus type="text"
                                                //     value={actionLabel} onChange={onChangeLabel} />
                                                <ItemLabel updateVariableByItemId={updateVariableByItemId} item={item} value={actionLabel} setChangeLabel={setChangeLabel} changeLabelField={changeLabelField} setActions={setActions} isEhFlow={isEhFlow} />

                                            }
                                            {
                                                item.conditions && item.conditions.length > 0 && (
                                                    <div className="field-condition-section">
                                                        <span className="field-condition-title">Conditions</span>
                                                        {item.conditions.map(fieldName => {
                                                            return item.fields[fieldName].functions.map((f, index) => f.conditions &&
                                                                <ConditionPicker conditions={f.conditions} name={f.name} key={index} />)
                                                            // return item.fields[fieldName].functions.map(f => f.conditions && f.conditions.map((condition, conditionI) =>
                                                            //     <div className="condition-area" key={conditionI}>
                                                            //         <div className="form-element wc">
                                                            //             <ConditionPicker condition={condition} name={f.name} onClick={(e) => { }} />
                                                            //         </div>
                                                            //         {condition.logic !== 'last' &&
                                                            //             <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                            //                 <div className="condition-tabs">
                                                            //                     <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            //                         value="and" onClick={(e) => { }}>
                                                            //                         And
                                                            //                     </button>
                                                            //                     <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            //                         value="or" onClick={(e) => { }}>
                                                            //                         Or
                                                            //                     </button>
                                                            //                 </div>
                                                            //             </div>
                                                            //         }
                                                            //     </div>
                                                            // ))
                                                            // return item.fields[fieldName].conditions.map(conditions => conditions.map((condition, conditionI) =>
                                                            //     <div className="condition-area" key={conditionI}>
                                                            //         <div className="form-element wc">
                                                            //             <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                            //         </div>
                                                            //         {condition.logic !== 'last' &&
                                                            //             <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                            //                 <div className="condition-tabs">
                                                            //                     <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            //                         value="and" onClick={(e) => { }}>
                                                            //                         And
                                                            //                     </button>
                                                            //                     <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            //                         value="or" onClick={(e) => { }}>
                                                            //                         Or
                                                            //                     </button>
                                                            //                 </div>
                                                            //             </div>
                                                            //         }
                                                            //     </div>
                                                            // ))
                                                        })}
                                                    </div>
                                                )

                                                // item.fields &&
                                                // Object.keys(item.fields).filter(key => item.fields[key].conditions && item.fields[key].conditions.length)?.map(fieldKey => {
                                                //     return item.fields[fieldKey].conditions.map(conditions => conditions.map((condition, conditionI) =>

                                                //         <div key={conditionI}>
                                                //             <div className="form-element">
                                                //                 <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                //             </div>
                                                //             {condition.logic !== 'last' &&
                                                //                 <div className="form-element" style={{ textAlign: 'center' }}>
                                                //                     <div className="condition-tabs">
                                                //                         <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                //                             value="and" onClick={(e) => { }}>
                                                //                             And
                                                //                         </button>
                                                //                         <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                //                             value="or" onClick={(e) => { }}>
                                                //                             Or
                                                //                         </button>
                                                //                     </div>
                                                //                 </div>
                                                //             }
                                                //         </div>
                                                //     ))
                                                // })
                                            }
                                        </div>

                                    ) :
                                    (
                                        <div
                                            onClick={(e) => {
                                                if (e.detail === 2) {
                                                    if (item.name !== 'START' && item.name !== 'STOP' && item.name !== 'TRIGGER') {
                                                        const name = t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
                                                        doubleClick(name)
                                                    }
                                                }
                                            }}
                                            className={`${item.conditions && item.conditions.length && "wc"} ${(item.name === 'STOP' || item.name === 'START') ? 'action-item-ss' : item.name !== 'TRIGGER' ? 'action-item' : ''}`}
                                            style={{ textAlign: "center", position: "relative" }}>
                                            {item.name !== 'START' && item.name !== 'STOP' && item.name !== 'TRIGGER' &&
                                                <span
                                                    className="action-item-lib">{t(`CONTENT.LIBRARY.${item.libraryName}.NAME`)}
                                                </span>
                                            }
                                            {
                                                item.name !== 'TRIGGER' && (
                                                    changeLabel && item.name !== 'START' && item.name !== 'STOP' ?
                                                        // <input style={{ border: '0', minWidth: '60px', maxWidth: '100%' }}
                                                        //     className="action-item-action"
                                                        //     onBlur={() => saveLabel(false)} autoFocus type="text"
                                                        //     value={actionLabel} onChange={onChangeLabel} /> 
                                                        <ItemLabel updateVariableByItemId={updateVariableByItemId} item={item} value={actionLabel} setChangeLabel={setChangeLabel} changeLabelField={changeLabelField} setActions={setActions} isEhFlow={isEhFlow} />

                                                        :
                                                        <div className='action-label-container'>
                                                            <span
                                                                className={`${item.name !== 'START' && item.name !== 'STOP' ? 'action-item-action' : 'action-item-sss'}`}>{item.label ? item.label : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`)}
                                                            </span>
                                                            {item.name !== 'START' && item.name !== 'STOP' && <span className='action-version-label'>v{item.version}</span>}
                                                        </div>
                                                )
                                            }
                                            {
                                                item.fields && item.fields.destination && item.fields.destination.value && item.fields.destination.value?.name &&
                                                <>
                                                    <div className='go-to-container' >
                                                        <IconButton onClick={(e) => GotoAction(e, item.fields.destination.value, isEhFlow)} className='go-to-button'>
                                                            <ExitToAppIcon />
                                                        </IconButton>
                                                        <div className='items-center' >
                                                            <span className='action-item-lib mr10' >{item.fields.destination.value.name}</span>

                                                            <img
                                                                className='mr10'
                                                                loading="lazy"
                                                                width="20"
                                                                src={item.fields.destination.value.image_path ? `${base_origin}${item.fields.destination.value.image_path}` : item.fields.destination.value.image}
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {
                                                item.name === 'DATA-TRANSFORM' && item?.fields?.data?.value?.outputVariable &&

                                                <div className='go-to-container' >
                                                    <div>
                                                        <div className='action-item-lib data-transform-title-margin' >{t(label + "TRANSFORM-VARIABLE")}</div>
                                                        <div className='items-center' >
                                                            {getVariableIcon(item.fields.data.value.sourceVariableType, "m-l-11")}
                                                            <div className='action-item-lib data-transform-variable-name' >{item.fields.data.value.outputVariable}</div>
                                                        </div>
                                                    </div>

                                                </div>

                                            }
                                            {
                                                item.conditions && item.conditions.length > 0 && (
                                                    <div className="field-condition-section">
                                                        <span className="field-condition-title">Conditions</span>
                                                        {item.conditions.map(fieldName => {
                                                            return item.fields[fieldName].functions.map((f, index) => f.conditions &&
                                                                <ConditionPicker conditions={f.conditions} name={f.name} key={index} />)
                                                        })}
                                                    </div>
                                                )

                                                // item.fields &&
                                                // Object.keys(item.fields).filter(key => item.fields[key].conditions && item.fields[key].conditions.length)?.map(fieldKey => {
                                                //     return item.fields[fieldKey].conditions.map(conditions => conditions.map((condition, conditionI) =>

                                                //         <div key={conditionI}>
                                                //             <div className="form-element">
                                                //                 <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                //             </div>
                                                //             {condition.logic !== 'last' &&
                                                //                 <div className="form-element" style={{ textAlign: 'center' }}>
                                                //                     <div className="condition-tabs">
                                                //                         <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                //                             value="and" onClick={(e) => { }}>
                                                //                             And
                                                //                         </button>
                                                //                         <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                //                             value="or" onClick={(e) => { }}>
                                                //                             Or
                                                //                         </button>
                                                //                     </div>
                                                //                 </div>
                                                //             }
                                                //         </div>
                                                //     ))
                                                // })
                                            }
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                    {item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                        <Info value={t("CONTENT.FLOW.ERROR-HANDLİNG-FLOW")} placement="right">
                            <div id={`error-icon-${item.id}`} className={`error-handling-icon ${item.fields?.errorFlow?.value ? "" : "d-n"}`} onClick={() => handleOpenErrorHandlingAutom(item)}>
                            </div>
                            {/* <div id={`error-icon-${item.id}`} className={`error-handling-icon`}>
                            </div> */}
                        </Info>
                    )}
                    {item.actionName !== 'STOP' && item.actionName !== 'TRIGGER' &&
                        <OptionsMenu item={item}
                            selectedItem={item}
                            index={index} setDialog={setDialog}
                            options={{
                                cut: (e) => handleDragStart(e, item, true, true),
                                copy: (e) => handleDragStart(e, item, undefined, true),
                                paste: (e) => handleOnDrop(e, item, index, undefined, undefined, true, groupable),
                                delete: handleDelete,
                                rename: doubleClick,
                                disable: disableAction,
                                resetSession: handleWPSession
                            }}
                            isCondition={item.flow_behavior?.includes('groupable')} />
                    }
                </div>
                {/* ------------------------------------Trigger Component Start------------------------------------ */}

                {/* NEW TRİGGER */}
                {item.name === 'TRIGGER' && <TriggerItem setTriggerArea={setTriggerArea} setTriggerModal={setTriggerModal}
                    setOpenSchedule={setOpenSchedule} setTriggerType={setTriggerType} item={item} handleResetTrigger={handleResetTrigger} />
                }
                {
                    item.name !== 'STOP' && item.name !== 'TRIGGER' && !item.tabParent &&
                    <div>
                        <div
                            className={`new-flow-line new-flow-vertical-line ${groupable?.children?.length - 1 === index ? "last-child" : ""} 
                            ${["IF", "ELSEIF", "ELSE"].includes(item.actionName) || (groupable?.libraryName === "DESKTOP-ACTIONS" && !isDesktopRecorder) ? "unvisible-flow-line" : ""}`} >
                            <div className='line-add-icon 1'>
                                <div className='quick-add-squire' onClick={() => setShowAddActionModal({ status: true, opt: { direction: undefined, isFirstChild: undefined } })}>
                                    <img className='add-action-icon' src={addActionIcon} />
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: '150px',
                                display: item.hiddenParent ? 'none' : 'flex',
                                justifyContent: 'center',
                                border: "1px solid transparent",
                                height: 30,
                                marginTop: "-54px",
                                zIndex: 9999,
                                position: "absolute",
                                left: "50%",
                                marginLeft: "-75px",
                                alignItems: "center"
                            }}
                            className={`new-flow-drag-hover ${groupable?.children?.length > 0 && groupable?.children?.length - 1 === index ? "bottom-draggable-area" : ""}`}
                            id={isDesktopRecorder && groupable?.children?.length > 0 && groupable?.children?.length - 1 === index ? `parent-id-${groupable.item_id}` : ""}
                            onDragEnter={(e) => handleDragEnter(e)}
                            onDragLeave={(e) => handleDragLeave(e)}
                            onDrop={(e) => { handleOnDrop(e, item, index, undefined, undefined, undefined, groupable) }}
                        >
                        </div>
                    </div>
                }
            </div>
        );
    };

    const groupableHtml = () => {
        return (
            <div className={`groupable-flow-container ${item.actionName === "ELSEIF" || item.actionName === "IF" ? "condition-container" : ""} ${!item.hiddenParent ? "dashed-connect" : ""}`}
                style={{ gridAutoFlow: item.flow_behavior.includes('horizontal') ? 'column' : 'row' }} ref={item.actionName === "ELSEIF" || item.actionName === "IF" ||
                    item.name === 'LIST-ITEM' || item.name === 'BUTTON-ITEM' ? ifAction : null}>
                <div className="new-flow-item-line"
                    onDragStart={(e) => handleDragStart(e, item, true)}
                    onDragOver={(e) => e.preventDefault()}
                >
                    <div className={lineDefinition + " new-flow-horizontal-item-line"}>
                        {item.actionName === "IF" || item.actionName === "ELSEIF" || item.name === 'LIST-ITEM' || item.name === 'BUTTON-ITEM' ?
                            <div className={`dst_${item.id} dashed-connect-line d-n ${item.actionName === "ELSEIF" && 'hide-left-border'}`}></div> : ""}
                        <div style={{
                            ...getExpandStyle(),
                            textAlign: 'center'
                        }}
                            className="new-flow-groupable-item"
                            draggable
                        >
                            <div id={`act_${item?.item_id !== undefined ? item?.item_id : item?.id}`}
                                className={item.type === 'groupable' ? `option-container groupable ${item?.item_id !== undefined ? item?.debugStatus : ""}` : "option-container " + (item?.item_id !== undefined ? item.debugStatus : "")}
                                style={{
                                    marginBottom: 10,
                                    display: item.hiddenParent ? 'none' : undefined
                                }}>
                                {/* <WarningRoundedIcon className="new-flow-warning-icon" id={'flow-warning' + item.id} /> */}
                                {item.actionName !== 'START' && (
                                    <Info value={t("CONTENT.FLOW.SHOW-ERROR")} placement="left">
                                        <ErrorSharpIcon
                                            onClick={handleErrorOpen}
                                            className={`debug-error-icon ${item?.debugStatus === 'error' ? 'show' : ''}`}
                                            id={'debug-error' + item.item_id} />
                                    </Info>
                                )}
                                {item.actionName !== 'START' && (
                                    <Info value={t("CONTENT.FLOW.FIELD-ERROR")} placement="left">
                                        <ErrorSharpIcon
                                            className={`debug-error-icon error`}
                                            id={'flow-warning' + item.id} />
                                    </Info>
                                )}
                                {(item.actionName !== 'IF' && item.actionName !== 'ELSEIF' && item.actionName !== 'ELSE') &&
                                    <IconButton className="option-icon" onClick={handleExpand} size="small"
                                        style={{ position: 'absolute', top: 0, left: -1 }}>
                                        <ExpandLessRounded fontSize='small'
                                            style={{
                                                color: 'black',
                                                transform: expand[item.id] ? 'rotate(180deg)' : 'rotate(0deg)'
                                            }}
                                        />
                                    </IconButton>
                                }
                                {/* border-${item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} */}
                                <div className={`action-container-border option-row version-active-${item.libraryName}-${item.version}
                                ${item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' ? "autom-action-count" : ""}`} onClick={(e) => {
                                        if (e.detail === 1) {
                                            handleSetActive(e);
                                        }
                                    }}>
                                    <div
                                        style={item.shade ? { backgroundColor: item.shade } : {}}
                                        className={`action-icon-border if ${item.name.toLowerCase()}-${item.conditionGroupId ? item.conditionGroupId : "group"}`}>
                                        <img style={{ width: 30 }} alt={item.libraryName}
                                            src={`${item.image_path ? `${base_origin}${item.image_path}` : fixBaseOrigin(base_origin, item.image)}`} />
                                    </div>

                                    {!item.hiddenParent && <OptionsMenu item={item}
                                        selectedItem={item} setDialog={setDialog}
                                        index={index}
                                        condition={condition}
                                        setDetailTabs={setDetailTabs}
                                        detailTabs={detailTabs}
                                        options={{
                                            cut: (e) => handleDragStart(e, item, true, true),
                                            copy: (e) => handleDragStart(e, item, undefined, true),
                                            paste: (e, direction, first) => (isDesktopRecorder || item?.actionName !== "SCOPE") ? handleOnDrop(e, item, index, direction, first, true, groupable) : null,
                                            delete: handleDelete,
                                            rename: doubleClick,
                                            resetSession: handleWPSession
                                        }}
                                        isCondition={item.flow_behavior?.includes('groupable')} />}
                                    <div onClick={(e) => {
                                        if (e.detail === 2) {
                                            let name;
                                            if ((item.action_name === 'GROUP' || item.action_name === 'BUTTON-SCOPE' || item.action_name === 'LIST-SCOPE' || item.action_name === 'TEXT')
                                                && item.fields?.label?.value) {
                                                name = item.fields.label.value
                                            } else {
                                                name = t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)
                                            }
                                            doubleClick(name)
                                        }
                                    }} className="new-flow-groupable-title action-item">
                                        <span className="action-item-lib">
                                            {t(`CONTENT.LIBRARY.${item.libraryName}.NAME`)}
                                        </span>
                                        {!changeLabel ?
                                            <div className='action-label-container'>
                                                <span className="group-action-name action-item-action">
                                                    {
                                                        (item.action_name === 'GROUP' || item.action_name === 'BUTTON-SCOPE' || item.action_name === 'LIST-SCOPE' || item.action_name === 'TEXT')
                                                            && item.fields?.label?.value ?
                                                            item.fields.label.value : item.label ? item.label :
                                                                t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)
                                                        // item.label ? item.label :
                                                        //     (item.action_name === 'GROUP' || item.action_name === 'BUTTON-SCOPE' || item.action_name === 'LIST-SCOPE' || item.action_name === 'TEXT')
                                                        //         && item.fields?.label?.value ?
                                                        //         item.fields.label.value :
                                                        //         t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)
                                                    }
                                                </span>
                                                <span className='action-version-label'>v{item.version}</span>
                                            </div> :
                                            // <input style={{ border: '0' }} className="action-item-action"
                                            //     onBlur={() => saveLabel(false)} autoFocus type="text"
                                            //     value={actionLabel} onChange={onChangeLabel} />
                                            <ItemLabel updateVariableByItemId={updateVariableByItemId} item={item} setChangeLabel={setChangeLabel} changeLabelField={changeLabelField} setActions={setActions} isEhFlow={isEhFlow} />
                                        }
                                    </div>
                                    {debuggingStart &&
                                        <IconButton disabled={debugRunning} size="small" onClick={(e) => handleDebugging(e, item)}
                                            style={{
                                                left: 0,
                                                top: item.name === 'IF' || item.name === 'ELSEIF' || item.name === 'ELSE' ? 2 : 20,
                                                position: 'absolute'
                                            }}>
                                            <BugReportIcon style={{
                                                fontSize: 18, color: item.isDebugging ? '#D75E5E' : 'black',
                                                display: 'inline-block !important'
                                            }} ref={refDebug} />
                                        </IconButton>}
                                    {isDesktopRecorder && item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                                        <IconButton size='small' style={{ right: -10, top: 24, position: 'absolute' }}
                                            onClick={() => desktopActionsEditDialog(item)}>
                                            <img src={editDesktopActionIcon} alt="" />
                                        </IconButton>
                                    )}
                                </div>
                                {item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                                    <Info value={t("CONTENT.FLOW.ERROR-HANDLİNG-FLOW")} placement="right">
                                        <div id={`error-icon-${item.id}`} className={`error-handling-icon ${item.fields?.errorFlow?.value ? "" : "d-n"}`} onClick={() => handleOpenErrorHandlingAutom(item)}>
                                        </div>
                                        {/* <div id={`error-icon-${item.id}`} className={`error-handling-icon`}>
                                        </div> */}
                                    </Info>
                                )}
                            </div>
                            <div
                                className={`${item.flow_behavior.includes('horizontal') ? 'groupable-horizontal-scope' : 'groupable-scope'}`}
                                style={{
                                    display: expand[item.id] ? 'none' : 'flex',
                                    flexDirection: item.flow_behavior.includes('horizontal') ? 'row' : 'column',
                                    position: "relative",
                                    marginTop: "30px",
                                    marginBottom: "30px"
                                }}>
                                {<>
                                    {item.children && item.children.length > 0 ?
                                        <>
                                            {item.actionName !== "BUTTON-SCOPE" &&
                                                <div
                                                    className={`new-flow-line new-flow-vertical-line first-child 
                                             ${item.libraryName === "DESKTOP-ACTIONS" && (!isDesktopRecorder || item.children[0]?.actionName === "PAGINATION") || item.hiddenParent ? "unvisible-flow-line" : ""}`}
                                                    onDrop={(e) => handleOnDrop(e, item, index)}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDragEnter={(e) => e.preventDefault()} >
                                                    <div className='line-add-icon start'>
                                                        <div className='quick-add-squire' onClick={() => setShowAddActionModal({ status: true, opt: { direction: "", isFirstChild: true } })}>
                                                            <img className='add-action-icon' src={addActionIcon} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <div
                                                style={{
                                                    width: '150px',
                                                    display: item.hiddenParent ? 'none' : 'flex',
                                                    justifyContent: 'center',
                                                    border: "1px solid transparent",
                                                    height: 30,
                                                    top: "-45px",
                                                    zIndex: 9999,
                                                    position: "absolute",
                                                    left: "50%",
                                                    marginLeft: "-75px"
                                                }}
                                                className="new-flow-drag-hover first-drag-hover"
                                                onDrop={(e) => handleOnDrop(e, item, index, '', true, undefined, item)}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDragEnter={(e) => handleDragEnter(e)}
                                                onDragLeave={(e) => handleDragLeave(e)}
                                            >
                                            </div>
                                        </> : !item.hiddenParent && (isDesktopRecorder || item.actionName !== "SCOPE") &&
                                        <div className="new-flow-drop-zone" id={isDesktopRecorder && `parent-id-${item.item_id}`}
                                            onClick={() => setShowAddActionModal({ status: true, opt: { direction: "", isFirstChild: true } })}
                                            onDrop={(e) => {
                                                handleOnDrop(e, item, index, '', true, undefined, item)
                                                e.target.style.borderColor = 'teal'
                                            }}
                                            onDragOver={(e) => e.preventDefault()}
                                            onDragEnter={(e) => e.target.style.borderColor = 'red'}
                                            onDragLeave={(e) => e.target.style.borderColor = 'teal'}>
                                            {t('CONTENT.FLOW.DROP')}
                                        </div>}
                                    {item.children && item.children.length > 0 && item.children.map((subItem, i) => (!subItem?.hidden &&
                                        <Item key={subItem.id} item={subItem} index={i} groupable={item}
                                            handleDragStart={handleDragStart}
                                            isConditionChild={false} setDetailTabs={setDetailTabs}
                                            conditionFlow={conditionFlow} hiddenParent={item.hiddenParent}
                                            setActiveItem={setActiveItem} detailTabs={detailTabs}
                                            deleteItem={deleteItem} setDialog={setDialog}
                                            isFocused={false} debuggingStart={debuggingStart}
                                            setShowTriggerRightArea={setShowTriggerRightArea}
                                            handleErrorOpenClick={handleErrorOpenClick}
                                            isEhFlow={isEhFlow}
                                            updateVariableByItemId={updateVariableByItemId}
                                            isDesktopRecorder={isDesktopRecorder}
                                            desktopActionsEditDialog={desktopActionsEditDialog}
                                            changeLabelField={changeLabelField}
                                            resetWPSession={resetWPSession}
                                            setActions={setActions}
                                            handleOpenErrorHandlingAutom={handleOpenErrorHandlingAutom}
                                            GotoAction={GotoAction}
                                            handleOnDrop={handleOnDrop}
                                            setTriggerType={setTriggerType}
                                        />
                                    ))}
                                </>}
                            </div>
                        </div>
                        {item.name !== 'ELSE' && conditionFlow !== 'row' &&
                            <div>
                                {/* TODO: Bu div kaldırıldığında ok hatası gidiyor. Kontrol edilecek. */}
                                {!item.hiddenParent && <div
                                    className={`new-flow-line new-flow-horizontal-line-condition ${item.name.toLowerCase()} ${groupable?.children?.length ? 'd-b' : 'd-n'}`}
                                    onDrop={(e) => handleOnDrop(e, item, index, 'column', undefined, undefined, groupable)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragEnter={(e) => e.preventDefault()}
                                >
                                    {/* <div className={`line-add-icon 2 ${groupable?.children?.length ? 'd-b' : 'd-n'}`}>
                                        <img className='add-action-icon' src={addActionIcon} />
                                    </div> */}
                                </div>}
                                <div
                                    className={"new-flow-drag-hover new-flow-drag-hover-condition " + `${item.name.toLowerCase()}`}
                                    onDrop={(e) => handleOnDrop(e, item, index, 'column', undefined, undefined, groupable, true)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragEnter={(e) => handleDragEnter(e)}
                                    onDragLeave={(e) => handleDragLeave(e, true)}
                                    style={{
                                        width: "100%",
                                        display: item.hiddenParent ? 'none' : 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: 30,
                                        border: "1px solid transparent",
                                        zIndex: 9999
                                    }}>
                                </div>
                            </div>
                        }
                        {/*{isConditionChild && conditionFlow !== 'row' && item.name !== 'ELSE' &&*/}
                        {/*<div>*/}
                        {/*    <div*/}
                        {/*        className={"new-flow-line new-flow-horizontal-line-condition " + item.name.toLowerCase()}*/}
                        {/*        condgroupid={item.conditionGroupId}*/}
                        {/*        onDrop={(e) => handleOnDrop(e,item,,index 'column')}*/}
                        {/*        onDragOver={(e) => e.preventDefault()}*/}
                        {/*        onDragEnter={(e) => e.preventDefault()}*/}
                        {/*    />*/}
                        {/*    <div*/}
                        {/*        className={"new-flow-drag-hover new-flow-drag-hover-condition " + item.name.toLowerCase()}*/}
                        {/*        condgroupid={item.conditionGroupId}*/}
                        {/*        onDrop={(e) => handleOnDrop(e,item,,index 'column')}*/}
                        {/*        onDragOver={(e) => e.preventDefault()}*/}
                        {/*        onDragEnter={(e) => handleDragEnter(e)}*/}
                        {/*        onDragLeave={(e) => handleDragLeave(e)}*/}
                        {/*        style={{*/}
                        {/*            width: "100%",*/}
                        {/*            display: item.hiddenParent ? 'none' : 'flex',*/}
                        {/*            justifyContent: 'center',*/}
                        {/*            alignItems: 'center',*/}
                        {/*            height: 30,*/}
                        {/*            border: "1px solid transparent",*/}
                        {/*            zIndex: 9999*/}
                        {/*        }}>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*}*/}
                    </div>
                    {(!isConditionChild || conditionFlow !== 'column') && item.name !== 'ELSE' && item.name !== 'LIST-ITEM' && item.name !== 'BUTTON-ITEM' && !item.tabParent &&
                        !isFocused &&
                        <div>
                            <div
                                className={`new-flow-line new-flow-vertical-line  ${groupable?.children?.length - 1 === index ? "last-child" : ""} 
                                ${["IF", "ELSEIF", "ELSE"].includes(item.actionName) || (item.libraryName === "DESKTOP-ACTIONS" && item.actionName !== "SCOPE" && !isDesktopRecorder) ? "unvisible-flow-line" : ""}`}
                                onDrop={(e) => handleOnDrop(e, item, index, 'row')}
                                onDragOver={(e) => e.preventDefault()}
                                onDragEnter={(e) => e.preventDefault()}
                            >
                                <div className='line-add-icon 3'>
                                    <div className='quick-add-squire' onClick={() => setShowAddActionModal({ status: true, opt: { direction: 'row', isFirstChild: undefined } })}>
                                        <img className='add-action-icon' src={addActionIcon} />
                                    </div>
                                </div>
                            </div>
                            <div className={`new-flow-drag-hover ${groupable?.children?.length - 1 === index ? "last-child-drag-hover" : ""} `}
                                id={isDesktopRecorder && groupable?.children?.length > 0 && groupable?.children?.length - 1 === index ? `parent-id-${groupable.item_id}` : ""}
                                onDragEnter={(e) => handleDragEnter(e)}
                                onDragLeave={(e) => handleDragLeave(e)}
                                onDrop={(e) => handleOnDrop(e, item, index, 'row')}
                                style={{
                                    width: '150px',
                                    display: item.hiddenParent ? 'none' : 'flex',
                                    justifyContent: 'center',
                                    border: "1px solid transparent",
                                    height: 30,
                                    marginTop: "-54px",
                                    zIndex: 9999,
                                    position: "absolute",
                                    left: "50%",
                                    marginLeft: "-75px"
                                }}>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    };

    const conditionHtml = () => {
        return (
            <div
                onDragStart={(e) => handleDragStart(e, item, true)}
                onDragOver={(e) => e.preventDefault()}
                onDragEnd={(e) => handleDragEnd(e)}
                className={` new-flow-item-line ${item.flow === 'column' ? 'justify-content-start' : 'justify-content-center'}`}>
                <div className="new-flow-groupable-item groupable-container option-condition new-flow-condition-color"
                    draggable style={{ gridAutoFlow: item.flow, position: 'relative', ...getConditionStyle() }}
                >
                    {item.children &&
                        item.children.map((subItem, i) =>
                            <Item key={subItem.id} item={subItem} index={i} condition={item}
                                handleDragStart={handleDragStart}
                                isConditionChild={true} setDetailTabs={setDetailTabs}
                                conditionFlow={"column"} hiddenParent={subItem.hiddenParent}
                                setActiveItem={setActiveItem} setDialog={setDialog}
                                deleteItem={deleteItem} detailTabs={detailTabs} groupable={item}
                                isFocused={false} debuggingStart={debuggingStart}
                                setShowTriggerRightArea={setShowTriggerRightArea}
                                handleErrorOpenClick={handleErrorOpenClick}
                                isEhFlow={isEhFlow}
                                updateVariableByItemId={updateVariableByItemId}
                                isDesktopRecorder={isDesktopRecorder}
                                desktopActionsEditDialog={desktopActionsEditDialog}
                                changeLabelField={changeLabelField}
                                resetWPSession={resetWPSession}
                                setActions={setActions}
                                handleOpenErrorHandlingAutom={handleOpenErrorHandlingAutom}
                                GotoAction={GotoAction}
                                handleOnDrop={handleOnDrop}
                                setTriggerType={setTriggerType}
                            />
                        )}
                    {!item.hiddenParent && <OptionsMenu item={item}
                        setDetailTabs={setDetailTabs}
                        detailTabs={detailTabs}
                        selectedItem={item} setDialog={setDialog}
                        index={index}
                        options={{
                            cut: (e) => handleDragStart(e, item, true, true),
                            copy: (e) => handleDragStart(e, item, undefined, true),
                            paste: (e) => handleOnDrop(e, item, index, undefined, undefined, true),
                            delete: handleDelete
                        }}
                        isCondition={item.flow_behavior?.includes('groupable')} />}
                </div>
                {!isFocused && !item.tabParent &&
                    <div>
                        <div
                            className={`new-flow-line new-flow-vertical-line ${groupable?.children?.length - 1 === index ? "last-child" : ""}
                             ${["IF", "ELSEIF", "ELSE"].includes(item.actionName) || (groupable?.libraryName === "DESKTOP-ACTIONS" && !isDesktopRecorder) ? "unvisible-flow-line" : ""}`}
                            onDrop={(e) => handleOnDrop(e, item, index)}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={(e) => e.preventDefault()} >
                            <div className='line-add-icon 4'>
                                <div className='quick-add-squire' onClick={() => setShowAddActionModal({ status: true, opt: { direction: undefined, isFirstChild: undefined } })}>
                                    <img className='add-action-icon' src={addActionIcon} />
                                </div>
                            </div>
                        </div>
                        <div
                            className="new-flow-drag-hover"
                            onDragEnter={(e) => handleDragEnter(e)}
                            onDragLeave={(e) => handleDragLeave(e)}
                            onDrop={(e) => {
                                handleOnDrop(e, item, index);
                            }}
                            style={{
                                width: "150px",
                                display: hiddenParent ? 'none' : 'flex',
                                justifyContent: 'center',
                                border: "1px solid translate",
                                height: 30,
                                // marginTop: "-54px",
                                marginTop: `${groupable?.children?.length - 1 === index ? "-24px" : "-55px"}`,
                                zIndex: 9999,
                                position: "absolute",
                                left: "50%",
                                marginLeft: "-75px"
                            }}>
                        </div>
                    </div>
                }
            </div>
        );
    };

    const addAction = () => {
        handleOnDrop({}, item, index, showAddActionModal.opt.direction, showAddActionModal.opt.isFirstChild, false);
        setShowAddActionModal({ status: false });
    }

    return (
        <>
            {item.type === 'standard' && standard()}
            {item.type === 'groupable' && groupableHtml()}
            {item.type === 'condition' && conditionHtml()}
            {/* {item.type === 'standard' && <Standard key={index} />} */}
            {/* {item.type === 'groupable' && <Groupable key={index} />} */}
            {/* {item.type === 'condition' && <Condition key={index} />} */}
            {showAddActionModal?.status && <AddActionModal selectAction={addAction} action={item} direction={showAddActionModal.opt.direction} close={() => setShowAddActionModal({ status: false })} isEhFlow={isEhFlow} />}
        </>
    );
}, areEqual);
export default Item;
